import { FC } from "react";
import MUI_Divider from "@mui/material/Divider";

interface DividerProps {
  margin?: number;
  marginTop?: number;
  marginBottom?: number;
  className?: string;
  color?: string;
}

const Divider: FC<DividerProps> = ({
  margin = 4,
  marginTop = margin,
  marginBottom = margin,
  className = "",
  color,
}) => {
  return (
    <MUI_Divider
      sx={{
        marginTop,
        marginBottom,
        borderColor: color || "theme.palette.divider",
      }}
      className={className}
    />
  );
};

export default Divider;
